"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  StampsMail: ['stamps-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15,18.048A6.751,6.751,0,1,1,18.75,12', 'M9.000 12.000 A3.000 3.000 0 1 0 15.000 12.000 A3.000 3.000 0 1 0 9.000 12.000 Z', 'M15,12v1.125a1.875,1.875,0,0,0,3.75,0V12', 'M21,16.5a2.247,2.247,0,0,1,.843-1.756,3.761,3.761,0,0,0,1.407-2.935,3,3,0,0,0-1.285-2.462,2.25,2.25,0,0,1,.227-3.833A2,2,0,0,0,23.25,3.75a3,3,0,0,0-3-3,2,2,0,0,0-1.764,1.058,2.25,2.25,0,0,1-3.742.349A3.761,3.761,0,0,0,11.809.75,3,3,0,0,0,9.347,2.035a2.25,2.25,0,0,1-3.833-.227A2,2,0,0,0,3.75.75a3,3,0,0,0-3,3A2,2,0,0,0,1.808,5.514a2.25,2.25,0,0,1,.349,3.742A3.761,3.761,0,0,0,.75,12.191a3,3,0,0,0,1.285,2.462,2.25,2.25,0,0,1-.227,3.833A2,2,0,0,0,.75,20.25a3,3,0,0,0,3,3,2,2,0,0,0,1.764-1.058,2.25,2.25,0,0,1,3.742-.349,3.761,3.761,0,0,0,2.935,1.407,3,3,0,0,0,2.462-1.285,2.25,2.25,0,0,1,3.833.227A2,2,0,0,0,20.25,23.25a3,3,0,0,0,3-3,2,2,0,0,0-1.058-1.764A2.249,2.249,0,0,1,21,16.5Z']],
  StampsFamous: ['stamps-famous', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,16.5a2.247,2.247,0,0,1,.843-1.756,3.761,3.761,0,0,0,1.407-2.935,3,3,0,0,0-1.285-2.462,2.25,2.25,0,0,1,.227-3.833A2,2,0,0,0,23.25,3.75a3,3,0,0,0-3-3,2,2,0,0,0-1.764,1.058,2.25,2.25,0,0,1-3.742.349A3.761,3.761,0,0,0,11.809.75,3,3,0,0,0,9.347,2.035a2.25,2.25,0,0,1-3.833-.227A2,2,0,0,0,3.75.75a3,3,0,0,0-3,3A2,2,0,0,0,1.808,5.514a2.25,2.25,0,0,1,.349,3.742A3.761,3.761,0,0,0,.75,12.191a3,3,0,0,0,1.285,2.462,2.25,2.25,0,0,1-.227,3.833A2,2,0,0,0,.75,20.25a3,3,0,0,0,3,3,2,2,0,0,0,1.764-1.058,2.25,2.25,0,0,1,3.742-.349,3.761,3.761,0,0,0,2.935,1.407,3,3,0,0,0,2.462-1.285,2.25,2.25,0,0,1,3.833.227A2,2,0,0,0,20.25,23.25a3,3,0,0,0,3-3,2,2,0,0,0-1.058-1.764A2.249,2.249,0,0,1,21,16.5Z', 'M6.75 6.75H17.25V17.25H6.75z', 'M12 6.75L9 12.75 12.75 12.75 12.75 17.25', 'M14.25,9.375a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  StampsImage: ['stamps-image', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,16.5a2.247,2.247,0,0,1,.843-1.756,3.761,3.761,0,0,0,1.407-2.935,3,3,0,0,0-1.285-2.462,2.25,2.25,0,0,1,.227-3.833A2,2,0,0,0,23.25,3.75a3,3,0,0,0-3-3,2,2,0,0,0-1.764,1.058,2.25,2.25,0,0,1-3.742.349A3.761,3.761,0,0,0,11.809.75,3,3,0,0,0,9.347,2.035a2.25,2.25,0,0,1-3.833-.227A2,2,0,0,0,3.75.75a3,3,0,0,0-3,3A2,2,0,0,0,1.808,5.514a2.25,2.25,0,0,1,.349,3.742A3.761,3.761,0,0,0,.75,12.191a3,3,0,0,0,1.285,2.462,2.25,2.25,0,0,1-.227,3.833A2,2,0,0,0,.75,20.25a3,3,0,0,0,3,3,2,2,0,0,0,1.764-1.058,2.25,2.25,0,0,1,3.742-.349,3.761,3.761,0,0,0,2.935,1.407,3,3,0,0,0,2.462-1.285,2.25,2.25,0,0,1,3.833.227A2,2,0,0,0,20.25,23.25a3,3,0,0,0,3-3,2,2,0,0,0-1.058-1.764A2.249,2.249,0,0,1,21,16.5Z', 'M6.75 6.75H17.25V17.25H6.75z']]
};
exports["default"] = _default;